import { render, staticRenderFns } from "./RecordDialog.vue?vue&type=template&id=60039b26&"
import script from "./RecordDialog.vue?vue&type=script&lang=js&"
export * from "./RecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecordDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports